module.exports = __webpack_public_path__ + "static/media/twitter-logo-charcoal.6e34c7c5.svg";